import classNames from 'classnames'
import * as React from 'react'

import { Button, TYPE } from 'components/Button'
import Icon from 'components/Icon'
import { UI } from 'Icon/ui'

import './Overlay.scss'

interface OverlayProps {
  open?: boolean
  label?: string | JSX.Element
  onClose?: () => void
  stickyStop?: boolean
  children?: React.ReactNode | undefined
}

const Overlay: React.FC<OverlayProps> = props => {
  const className = classNames(
    'srprs-overlay',
    props.open ? 'is-open' : '',
    props.stickyStop ? 'absolute' : '',
  )

  return (
    <div className={className}>
      <div className="wrapper">
        <div className="wrapper-inner">
          <Button type={TYPE.square} onClick={props.onClose}>
            <span>{props.label}</span>
            <Icon icon={UI.chevronDown} />
          </Button>
          {props.children}
        </div>
      </div>
    </div>
  )
}

Overlay.defaultProps = {
  open: false,
}

export default Overlay
